import TypesenseError from "./TypesenseError";

export default class ServerError extends TypesenseError {}
